export const FULLY_QUALIFIED_TYPE_NAMES = {
  GetUserProfileInfoResponse:
    'com.amazon.passportusermanagementservice#GetUserProfileInfoResponse',
  UserIdentifier:
    'com.amazon.passportusermanagementservice#ExternalCustomerIdentifier',
  UpdateUserProfileInfoRequest:
    'com.amazon.passportusermanagementservice#UpdateUserProfileInfoRequest',
  UpdateUserProfileInfoResponse:
    'com.amazon.passportusermanagementservice#UpdateUserProfileInfoResponse',
  AcceptInvitationRequest:
    'com.amazon.passportusermanagementservice#AcceptInvitationRequest',
  GetInvitedUsersForLogisticsPartyResponse:
    'com.amazon.passportusermanagementservice#GetInvitedUsersForLogisticsPartyResponse',
  GetUsersForLogisticsPartyResponse:
    'com.amazon.passportusermanagementservice#GetUsersForLogisticsPartyResponse',
  CreateInvitationRequest:
    'com.amazon.passportusermanagementservice#CreateInvitationRequest',
  EmailInvitationChannelInfo:
    'EmailInvitationChannelInfo:http://internal.amazon.com/coral/com.amazon.passportusermanagementservice/',
  GetDeactivatedUsers:
    'com.amazon.passportusermanagementservice#GetDeactivatedUsersResponse',
  GetRequestedUserProfileInfoResponse : 
    'com.amazon.passportusermanagementservice#GetRequestedUserProfileInfoResponse',
};

export default FULLY_QUALIFIED_TYPE_NAMES;
